import React from "react";
import { withStyles, createStyles, WithStyles, Theme } from "@material-ui/core/styles";

import Grid from "../lib/components/grid";
import { GridColumnsSelected } from "./loadouttabledetailsetup";

type LoadoutTableSelectedGridProps = {
    data: any[];
    loading: boolean;
    gridHeight: number;
    clearFilters?: string;
    handleRefresh?: () => void;
    rowRenderer?: (props: any) => React.ReactElement;
    totalRowColumns?: string[];
} & WithStyles<typeof styles>;

const styles = (theme: Theme) =>
    createStyles({
        root: {
            height: "100%",
            width: "100%",
        },
    });

class LoadoutTableSelectedGridUnstlyed extends React.Component<LoadoutTableSelectedGridProps, {}> {
    render() {
        const { classes, data, loading, gridHeight, clearFilters, handleRefresh, rowRenderer, totalRowColumns } = this.props;

        return (
            <div className={classes.root}>
                <Grid
                    forceHeight={gridHeight}
                    loading={loading}
                    data={data}
                    GridColumns={(data, filters, columnArrangement, columnsWidth) =>
                        GridColumnsSelected(data, filters, columnArrangement, columnsWidth)
                    }
                    rowRenderer={rowRenderer}
                    handleRefresh={handleRefresh}
                    clearFilters={clearFilters}
                    totalRowColumns={totalRowColumns}
                />
            </div>
        );
    }
}

export default withStyles(styles)(LoadoutTableSelectedGridUnstlyed);